module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Birthdate":"Birthdate","Dependents":"Dependents","Years of schooling":"Years of schooling"},"es":{"Birthdate":"Fecha de Nacimiento","Dependents":"Personas a cargo (económicamente)","Years of schooling":"Años de Escolaridad"},"sw":{"Birthdate":"Siku ya kuzaliwa","Dependents":"Wategemezi","Years of schooling":"Kusoma"}}')
  delete Component.options._Ctor
}
